<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.epcTypologyInfo.title') }}
  template(#content)
    AddressSearch(:hideTitle="true")
    SelectionErrorMessage(v-if="errorMessage" :message="errorMessage")
    AddressTypologyInfoUK(:epcData="epcData")
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import Card from "primevue/card";
import SearchInput from "@/components/forms/components/SearchInput.vue";
import SelectionErrorMessage from "@/components/forms/components/SelectionErrorMessage.vue";
import AddressSearch from "../AddressSearch.vue";
import AddressTypologyInfoUK from "./AddressTypologyInfoUK.vue";

import { useSelections } from "@/store";
import { storeToRefs } from "pinia";
import { LayoutEvent, emit } from "@/helpers";

export default defineComponent({
  components: {
    Card,
    SearchInput,
    SelectionErrorMessage,
    AddressSearch,
    AddressTypologyInfoUK,
  },
  setup() {
    const selection = useSelections();
    const { loadEpcData } = selection;
    const { houseTypologySelected, epcData, addressResult } =
      storeToRefs(selection);
    watch([addressResult], async () => {
      errorMessage.value = undefined;
      emit(LayoutEvent.ShowHouseInfoForm, false);
      try {
        if (addressResult.value) {
          await loadEpcData();
        }
      } catch (e) {
        epcData.value = undefined;
        houseTypologySelected.value = undefined;
        errorMessage.value = (e as Error).message;
      }
    });

    const isLoading = ref(false);
    const errorMessage = ref<string>();

    return {
      isLoading,
      errorMessage,
      houseTypologySelected,
      epcData,
      addressResult,
    };
  },
});
</script>
<style scoped lang="scss">
.selections-card:deep(.address-search) {
  padding: 0;
  margin: 0;
  box-shadow: none;

  .p-card-content {
    padding: 0;
  }
}

.wrapper {
  align-items: center;

  .ber-error {
    bottom: 2rem;
    padding: 0.5rem;
    font-size: small;
  }
}
</style>
